function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .AgregarHE {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "AgregarHE",
  d: "M6.8,2.8v-.6h1.6v.6c0,.3.3.6.6.6h.1c.3,0,.6-.3.6-.6v-.6h1.6v.6c0,.3.3.6.6.6h.1c.3,0,.6-.3.6-.6v-.6h.3l1.1,1.1v1.7h1.1v-2.2l-1.7-1.7h-.8v-.6c0-.3-.3-.6-.6-.6h-.1c-.3,0-.6.3-.6.6v.6h-1.6v-.6c0-.3-.3-.6-.6-.6h-.1c-.3,0-.6.3-.6.6v.6h-1.6v-.6c0-.3-.3-.6-.6-.6h-.1c-.3,0-.6.3-.6.6v.6h-1.6v-.6c0-.3-.3-.6-.6-.6h-.1c-.3,0-.6.3-.6.6v.6H0v16.9h5l.3-1.1H1.1V2.3h1.5v.6c0,.3.3.6.6.6h.1c.3,0,.6-.3.6-.6v-.6h1.6v.6c0,.3.3.6.6.6h.1c.3,0,.6-.3.6-.6Z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "AgregarHE",
  points: "14.4 9.4 12.2 9.4 12.2 12 9.6 12 9.6 14.2 12.2 14.2 12.2 16.8 14.4 16.8 14.4 14.2 17.1 14.2 17.1 12 14.4 12 14.4 9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "AgregarHE",
  d: "M13.3,6.1c-3.9,0-7,3.1-7,7s3.1,7,7,7,7-3.1,7-7-3.1-7-7-7ZM13.3,19c-3.3,0-5.9-2.6-5.9-5.9s2.6-5.9,5.9-5.9,5.9,2.6,5.9,5.9-2.6,5.9-5.9,5.9Z"
}));

var SvgAgregarACt = function SvgAgregarACt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 20.3 20.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgregarACt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Agregar ACt.e0a440b8.svg";
export { ForwardRef as ReactComponent };